<template>
  <div class="coupon" mg-stat-mod="c_hwcouponpop">
    <ul v-if="noSelcet" class="coupon__tab no-select">
      <li @click="changeUseStatus(0)">未使用</li>
      <li @click="changeUseStatus(1)">已使用</li>
      <li @click="changeUseStatus(2)">已过期</li>
      <div ref="line" class="coupon__tab-line line"></div>
    </ul>
    <ul v-else class="coupon__tab">
      <li
          :mg-stat-custom="'label=li&cont=可用优惠券tab&direct=cntp'"
          mg-stat-click
          @click="changeAvailable(1)"
      >
        可用优惠券（{{ availableList.length }}）
      </li>
      <li
          :mg-stat-custom="'label=li&cont=不可用优惠券tab&direct=cntp'"
          mg-stat-click
          @click="changeAvailable(0)"
      >
        不可用优惠券（{{ disabledList.length }}）
      </li>
      <div ref="line" class="coupon__tab-line"></div>
    </ul>
    <div :class="contentClass">
      <div v-if="showEmpty" class="empty-select">
        <img src="../../../assets/img/empty_icon.png"/>
        <p>暂无优惠券~</p>
      </div>
      <div
          v-for="(item, index) in couponList"
          :key="index"
          :mg-stat-custom="`cont=${item.couponSn}&direct=cntp&label=coupon`"
          class="coupon__item"
          mg-stat-click
          @click="getNowId(item)"
      >
        <div :class="['coupon__item-price', isDisabled ? 'disabled' : '']">
          <div v-if="item.saleType === 1">
            <p>
              <b>￥</b>
              <span>{{ item.money }}</span>
            </p>
            <p>{{ getLimitTitle(item.condition) }}</p>
          </div>
          <div v-else-if="item.saleType === 2" class="coupon__item-salep">
            <img class="coupon__item-saletype" src="~assets/img/goods_sale_coupon.png">
            <p>实物兑换券</p>
          </div>
          <div v-else-if="item.saleType === 3">
            <p style="text-align: center">
              <span>{{ getDisCount(item.discount) }} </span>
              <b>折</b>
            </p>
            <p>{{ getLimitTitle(item.condition) }}</p>
          </div>
        </div>
        <div :class="['coupon__item-main', isDisabled ? 'disabled' : '']">
          <div class="coupon__item-desc">
            <p class="add_dot2">
              <span class="tag">{{ getUseType(item.useType) }}</span>
              {{ item.couponInfo }}
            </p>
            <p :class="['coupon__item-date', isDisabled ? 'disabled' : '']">
              <span>{{ getDateTip(item) }}</span>
              <span v-if="getFinishLabel(item)">{{
                  getFinishLabel(item)
                }}</span>
            </p>
            <p
                v-if="isDisabled && item.unavailableReason"
                class="coupon__item-tips"
            >
              <i class="icon warning"></i>
              <span>{{ item.unavailableReason }}</span>
            </p>
            <span v-if="readonly && useStatus===0" class="use">去使用</span>
          </div>
          <i
              v-if="showCheckIcon && nowId === item.couponSn"
              class="icon selected"
          ></i>
          <span v-else-if="showCheckIcon" class="not-select"></span>
        </div>
        <div
            :class="['coupon__item-circle top', isDisabled ? 'disabled' : '']"
        ></div>
        <div
            :class="['coupon__item-circle bottom', isDisabled ? 'disabled' : '']"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
import { dateFormater, getRemainingTime, transLateTime } from 'utils/date';

export default {
  props: ['list', 'noSelcet', 'goodsids', 'readonly'],
  data() {
    return {
      canUse: 1,
      nowId: 0,
      useStatus: 0,
      saleType: 1,
      couponList: [],
      availableList: [],
      disabledList: [],
      showEmpty: true,
    };
  },
  watch: {
    list: {
      handler(val) {
        if (val != null && val.length > 0) {
          this.availableList = val.filter(f => f.available === 1);
          this.disabledList = val.filter(f => f.available === 0);
          this.notUseList = val.filter(f => f.useStatus === 0);
          this.usedList = val.filter(f => f.useStatus === 1);
          this.expiredList = val.filter(f => f.useStatus === 2);
          this.getAvailableList();
          this.getUseStatusList();
        }
      },
      immediate: true,
    },
  },
  computed: {
    isDisabled() {
      if (this.noSelcet) {
        return this.useStatus !== 0;
      }
      return this.canUse === 0;
    },
    contentClass() {
      let className = 'coupon__content scroll-touch';
      if (this.noSelcet) {
        className += ' no-select';
      }
      return className;
    },
    showCheckIcon() {
      return !this.noSelcet && this.canUse;
    },
  },
  methods: {
    getUseType(val) {
      // 0全店通用1指定商品可用2指定分类商品可用
      if (val === 0) {
        return '全店通用';
      } else if (val === 1) {
        return '指定商品可用';
      } else if (val === 2) {
        return '指定分类商品可用';
      }
    },
    getLimitTitle(val) {
      if (Number(val) > 0) {
        return `满${Number(val).toFixed(0)}元可用`;
      }
      return '无门槛';
    },
    changeAvailable(val) {
      this.canUse = val;
      const ele = this.$refs.line;
      if (val) {
        ele.style.left = '9%';
      } else {
        ele.style.left = '60%';
      }
      this.getAvailableList();
    },
    changeUseStatus(val) {
      const ele = this.$refs.line;
      this.useStatus = val;
      if (val === 0) {
        ele.style.left = '8.6%';
      } else if (val === 1) {
        ele.style.left = '42%';
      } else {
        ele.style.left = '75%';
      }
      this.getUseStatusList();
    },
    getUseStatusList() {
      const { useStatus } = this;
      if (!this.noSelcet) {
        return;
      }
      if (useStatus === 0) {
        this.couponList = this.notUseList;
      } else if (useStatus === 1) {
        this.couponList = this.usedList;
      } else {
        this.couponList = this.expiredList;
      }
      this.showEmpty = this.couponList == null || this.couponList.length === 0;
    },
    getAvailableList() {
      const { canUse } = this;
      if (this.noSelcet) {
        return;
      }
      if (canUse) {
        this.couponList = this.availableList;
      } else {
        this.couponList = this.disabledList;
      }
      this.showEmpty = this.couponList == null || this.couponList.length === 0;
    },
    getDays(time) {
      const nowTime = new Date().getTime();
      const endTime = transLateTime(time);
      const {
        days, hours, minutes, seconds,
      } = getRemainingTime(
        nowTime,
        endTime,
      );
      return {
        days,
        hours,
        minutes,
        seconds,
      };
    },
    getDateTip({ useStartTime, useEndTime, status }) {
      // const { days } = this.getDays(use_end_time);
      // const getDate = (time) => {
      //   const [val] = time.split(' ');
      //   return val.replace(/-/g, '.');
      // };
      if (status === 2) {
        return '已失效';
      }
      return `${dateFormater(useStartTime * 1000, 'yyyy-MM-dd')} 至 ${dateFormater(useEndTime * 1000, 'yyyy-MM-dd')}`;
    },
    getFinishLabel(item) {
      const {
        days, hours, minutes, seconds,
      } = this.getDays(item.useEndTime);
      const { status } = item;
      if (status === 2) {
        return false;
      }
      if (days <= 7) {
        if (days > 0) {
          return `(仅剩${days + 1}天)`;
        }
        if (hours > 0) {
          return `(仅剩${hours}小时)`;
        }
        if (hours === 0 && minutes >= 0 && seconds >= 0) {
          return '(即将到期)';
        }
      }
      return false;
    },
    getNowId({
      couponId, couponSn, money, saleType, name, useType,
    }) {
      if (this.readonly) {
        // 从列表页过来，跳转到券可用商品页面
        if (useType === 0) {
          this.$router.push({ path: '/home' });
        } else {
          this.$router.push({ path: '/coupon/goods', query: { id: couponId, showBack: 1 } });
        }
      } else {
        if (!this.canUse) {
          return;
        }
        let price = money;
        if (!couponSn || couponSn === this.nowId) {
          this.nowId = 0;
          price = 0;
        } else {
          this.nowId = couponSn;
        }
        this.$emit('change', {
          id: this.nowId, price, canUse: this.canUse, saleType, name,
        });
      }
    },
    getDisCount(discount) {
      // 80 显示 8折  82 显示82折
      return discount % 10 ? discount : discount / 10;
    },
  },
};
</script>
<style lang="scss" scoped>
.coupon {
  height: 100%;
  display: flex;
  flex-direction: column;

  &__tab {
    display: flex;
    height: 52px;
    border-bottom: 1px solid #d3d3d3;
    color: #4a4a4a;
    font-size: 26px;
    position: relative;
    margin-bottom: 20px;

    li {
      width: 50%;
      text-align: center;
      padding-bottom: 16px;
    }

    &.no-select {
      justify-content: space-between;
      padding: 0 65px;

      li {
        width: 120px;
        text-align: center;
        padding-bottom: 16px;
      }

      .line {
        width: 120px;
        left: 8.6%;
      }
    }

    &-line {
      position: absolute;
      bottom: 0px;
      width: 195px;
      left: 9%;
      height: 6px;
      background: rgba(255, 99, 4, 1);
      border-radius: 5px;
      transition: 0.3s ease-in-out;
    }
  }

  &__content {
    flex: 1;
    padding-bottom: 50px;

    &.no-select {
      padding: 0 20px 50px 20px;
    }

    .empty-select {
      text-align: center;
      margin: 0 auto; /*水平居中*/
      position: relative;
      top: 50%; /*偏移*/
      transform: translateY(-50%);

      p {

        font-size: 28px;
        color: #A8A8A8FF;
      }

      img {
        height: 122px;
        width: 122px;
        /*margin-top: 358px;*/
      }
    }

  }

  &__item {
    margin-bottom: 20px;
    display: flex;
    height: 158px;
    position: relative;
    overflow: hidden;

    &-circle {
      position: absolute;
      border: 1px solid #ffe2d0;
      width: 20px;
      height: 20px;
      background: #fff;
      border-radius: 60%;
      left: 190px;

      &.disabled {
        border-color: #e9e9e9;
      }

      &.top {
        top: -15px;
      }

      &.bottom {
        bottom: -15px;
      }
    }

    &-price {
      width: 199px;
      border-radius: 6px;
      background: linear-gradient(
              114deg,
              rgba(255, 124, 8, 1) 0%,
              rgba(255, 89, 22, 1) 100%
      );
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      &.disabled {
        background: #c2c2c2;

        p {
          color: #fff;
        }
      }

      p {
        color: #fff;

        b {
          font-size: 30px;
        }

        &:nth-of-type(1) {
          font-size: 48px;
        }

        &:nth-of-type(2) {
          font-size: 22px;
          margin-top: 8px;
        }
      }
    }

    &-salep {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      p {
        margin-top: 11px;
        font-size: 28px !important;
      }
    }

    &-saletype {
      width: 46px;
      height: 40px;
      display: block;
      text-align: center;
    }

    &-main {
      flex: 1;
      height: 100%;
      background: #fff6f1;
      border: 1px solid #ffe2d0;
      border-radius: 6px;
      padding: 18px 35px 30px 20px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &.disabled {
        background: #e9e9e9;
        border: none;
        padding-bottom: 0;

        .tag {
          background: #c2c2c2;
        }
      }
    }

    &-desc {
      flex: 1;
      height: 100%;

      p {
        width: 100%;

        &:nth-of-type(1) {
          font-size: 22px;
          height: 65px;
        }
      }

      .tag {
        font-size: 22px;
        color: #fff;
        border-radius: 13px;
        padding: 2px 10px;
        margin-right: 18px;
        background: #ff5f00;
      }

      .desc {
        width: 250px;
        font-size: 22px;
        color: #515359;
        margin-left: 16px;
        line-height: 26px;
        max-height: 60px;
        padding-top: 6px;

        &.no-select {
          width: 300px;
        }
      }

      .use {
        position: absolute;
        top: 0px;
        right: 0px;
        font-size: 20px;
        line-height: 50px;
        width: 40px;
        padding: 0px 8px;
        padding-top: 5px;
        box-sizing: border-box;
        height: 100%;
        word-break: break-all;
        color: #fff;
        background-color: #ff5916;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        font-family: PingFangSC, Helvetica Neue, Helvetica, Arial, sans-serif;
      }
    }

    &-tips {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #515359;
      height: 28px;
      line-height: 28px;

      i {
        margin-right: 10px;
      }
    }

    &-date {
      height: 28px;
      line-height: 28px;

      &.disabled {
        margin-top: -10px;
        margin-bottom: 25px;
      }

      span {
        &:nth-of-type(1) {
          font-size: 20px;
          color: #515359;
          margin-right: 15px;
        }

        &:nth-of-type(2) {
          font-size: 20px;
          color: #ff4c00;
        }
      }
    }

    .not-select {
      width: 32px;
      height: 32px;
      background: #fff;
      border-radius: 50%;
      border: 2px solid #ff5e00;
    }
  }
}
</style>

